import { render } from "./ModalEditFileAttributes.vue?vue&type=template&id=0c31c8d8&scoped=true"
import script from "./ModalEditFileAttributes.vue?vue&type=script&lang=js"
export * from "./ModalEditFileAttributes.vue?vue&type=script&lang=js"

import "./ModalEditFileAttributes.vue?vue&type=style&index=0&id=0c31c8d8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c31c8d8"]])

export default __exports__